
import { defineComponent } from 'vue'

export default defineComponent({
    name: "widget-15",
    props: {
        widgetClasses: String,
        icon: String,
        title: {
            type: null,
            required: true,
            default: ""
        },
        subTitle: {
            type: String,
            required: false,
            default: ""
        }
    }
})
